import { ButtonProps, ButtonType, ButtonWidget, TabStyles } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/common/utilities/ImgUrl';


export interface LinkedTaskDeleteTaskButtonProps {
  id: string;
  onDelete: () => void;
  style?: React.CSSProperties; // add addional style props
}

export function LinkedTaskDeleteTaskButton(props: LinkedTaskDeleteTaskButtonProps) {
  const buttonProps: ButtonProps = {
    title: Messages.linkedTasksDeleteTask(),
    buttonType: ButtonType.Icon,
    testId: 'linked-task-delete-button',
    style: {
      padding: `${TabStyles.Spacing.SmallSpace}px`,
      marginLeft: `${TabStyles.Spacing.SmallSpace}px`,
      height: 26,
      ...props.style,
    },
    handleClick: props.onDelete,
  };

  return (
    <ButtonWidget {...buttonProps}>
      <img src={imgPath('trash_14px_small.svg')} alt={Messages.linkedTasksDeleteTask()} style={{marginRight: 6}}/>
      {Messages.linkedTasksDeleteTask()}
    </ButtonWidget>
  );
}
